const header = {
  upgrade: 'Upgrade Plan',
  profile: 'Profile',
  changeLanguage: 'Switch Language',
  simplifiedChinese: 'Simplified Chinese',
  english: 'English',
  logout: 'Logout',
  tagName: 'Tag Name',
  createSuccess: 'Created Successfully',
  cancel: 'Cancel',
  confirm: 'Confirm',
  extensionStatus: 'Status',
  extensionChecking: 'Checking',
  extensionConnected: 'Connected',
  extensionMissing: 'Not installed',
  extensionRetry: 'Click to check again',
  adminMode: 'Admin Mode',
  on: 'On',
  off: 'Off',
  notifications: 'Notifications',
  unreadNotifications: 'Notifications, unread messages',
  expandSidebar: 'Expand sidebar',
  collapseSidebar: 'Collapse sidebar',
  notificationCurrent: 'Now',
  announcementTitle: 'Double 11 offers are here',
  announcementDesc:
    'Explore limited-time Double 11 offers on the plans page. The event ends on November 11, 2026 at 23:59 (UTC+8).',
  pin: 'Pin',
  unpin: 'Unpin',
  rename: 'Rename',
  delete: 'Delete',
  deleteConfirm: 'Delete tag "{name}"?',
  deleteSuccess: 'Deleted Successfully',
  updateSuccess: 'Updated Successfully',
  renameTitle: 'Rename Tag',
  newName: 'New Name',
}

export default header
